import { Sport } from "@/graphql/gql/graphql";
import PlayerNewsContainer from "./PlayerNewsContainer";
import PlayerNewsHeader from "./PlayerNewsHeader";

type PlayerNewsProps = {
  sportName: Sport["name"];
  sportSlug: Sport["slug"];
};

const PlayerNews = ({ sportName, sportSlug }: PlayerNewsProps) => (
  <div>
    <PlayerNewsHeader sportName={sportName} sportSlug={sportSlug} />
    <PlayerNewsContainer sportName={sportName} />
  </div>
);

export default PlayerNews;
